import { cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { getDotClassName } from './dot.styles';
import { DotProps } from './types';

export type ColoredDotProps = Omit<CommonHTMLAttributes, 'color'> & {
  children?: React.ReactNode;
  hoverText?: string;
};

export const Dot: React.FC<React.PropsWithChildren<DotProps>> = ({
  color,
  innerRef,
  pulsing = false,
  className,
  ...rest
}) => {
  return <div className={cx(getDotClassName({ color, pulsing }), className)} ref={innerRef} {...rest} />;
};
